import React, { useState } from 'react';
import BalanceGridRow from '../types';
import { Button, Icon, Input, Message, Popup } from 'semantic-ui-react';
import { BalancesGridContext } from '../Balances/BalancesGrid';
import { GridApi } from 'ag-grid-community';
import { AMLState } from 'ts/models/Account.model';

type Props = {
  data: BalanceGridRow;
  context: BalancesGridContext;
  api: GridApi;
};

export const AML_VALUES: AMLState[] = ['flagged', 'unflagged'];
const getUpdateObject = (prev: AMLState, amlComment: string) => {
  return {
    amlComment,
    amlState: prev === 'flagged' ? 'unflagged' : 'flagged',
  };
};

const AMLRenderer = ({ data, api, context }: Props) => {
  const flagged = data?.amlState === 'flagged';
  const [comment, setComment] = useState(data?.amlComment || '');
  return (
    <Popup
      disabled={context?.isReadOnlyRole}
      trigger={
        <Icon
          link
          name={flagged ? 'flag' : 'flag outline'}
          color={flagged ? 'red' : 'black'}
        />
      }
      on="click"
      content={
        <>
          <Message info>
            <Message.Header>Comments:</Message.Header>
            <p>{data?.amlComment}</p>
          </Message>
          <div className="flex-row">
            <Input
              name="comment"
              placeholder="Enter Comment"
              required
              value={comment}
              onChange={(e, { value }) => {
                setComment(value);
              }}
            />
            <Button
              labelPosition="right"
              color={data?.amlState === 'flagged' ? 'green' : 'red'}
              icon="flag"
              content={data?.amlState === 'flagged' ? 'Unflag' : 'Flag'}
              onClick={() =>
                context?.updateAccount(api, {
                  accountId: data?.accountId,
                  update: getUpdateObject(data?.amlState, comment),
                })
              }
            />
          </div>
        </>
      }
    />
  );
};

export default AMLRenderer;
